import type { PathType } from './types';
import { getPath } from './types';

export const commonPaths: { [key: string]: PathType } = {
  home: getPath('/', ['v2.sidebar.home']),
  systemAdmin: getPath('/system-admin', ['sidebar.home', 'v2.interactive.index', 'v2.crm.systemAdmin.index']),

  // Auth related paths
  logout: getPath('/logout', []),
  signinOidc: getPath('/signin-oidc', []),
  signoutOidc: getPath('/signout-oidc', []),
  signoutCallbackOidc: getPath('/signout-callback-oidc', []),

  // Error pages
  serverError: getPath('/server-error', [])
};
